<template>
  <app-layout>
    <template v-if="currentEmployee">
      <v-flex>
        <v-alert
          :value="isInactive"
          type="warning"
          class="mb-3"
        >
          {{ $t('currently_inactive') }}
        </v-alert>
        <v-card>
          <v-toolbar
            color="white"
            flat>
            <v-toolbar-title>{{ currentEmployee.first_name }} {{ currentEmployee.last_name }}</v-toolbar-title>
            <v-spacer/>
            <v-btn
              icon
              @click="navigateByRole">
              <v-icon>settings</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card>

        <employee-timesheet-table :periods-excluded-months="periodsExcludedMonths"/>

        <employee-inactivity-table />
      </v-flex>
    </template>
  </app-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import EmployeeInactivityTable from './EmployeeInactivityTable'
import EmployeeTimesheetTable from './timesheets/EmployeeTimesheetTable'

export default {
  name: 'EmployeeOverview',
  components: { EmployeeTimesheetTable, EmployeeInactivityTable },
  data () {
    return {
      periodsExcludedMonths: null
    }
  },
  computed: {
    ...mapGetters('employee', ['currentEmployee']),
    isInactive () {
      let isInactive = false
      if (this.periodsExcludedMonths) {
        this.periodsExcludedMonths.map(month => {
          const now = this.$moment()
          const date = this.$moment(month, 'MM.YYYY')
          if (now.isSame(date, 'month')) isInactive = true
        })
      }
      return isInactive
    }
  },
  methods: {
    navigateByRole () {
      this.$router.push({ name: 'employeeSettings.personal', params: { employeeId: this.currentEmployee.id } })
    }
  },
  created () {
  },
  i18n: {
    messages: {
      en: {
        currently_inactive: 'Currently inactive'
      },
      tr: {
        currently_inactive: 'Etkisiz'
      },
      de: {
        currently_inactive: 'Aktuell inaktiv'
      },
      ru: {
        currently_inactive: 'неактивный'
      }
    }
  }
}
</script>

<style scoped>

</style>
